import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, navigate } from '@reach/router';
import { useMutation } from '@apollo/client';

import Wrapper from '../elements/wrapper';
import SEO from '../seo';
import { media, TransitionMixin } from '../helpers';
import { LOGIN_MUTATION } from './mutations';

const LoginContainer = styled.div`
    ${media.medium`min-height: calc(100vh - 108px);`}
    display: flex;
    padding-top: 15vh;
    .form-container {
        max-width: 600px;
        margin: 0 auto;
        text-align: center;

        .title-container {
            margin-bottom: 30px;
            h1 {
                font-size: 4rem;
                margin: 0;
                color: #000;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
            }
        }

        form {
            .input-container {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 20px;

                &.submit {
                    align-items: baseline;
                }

                label {
                    flex: 1 1 100%;
                    text-align: left;
                    font-weight: bold;
                    color: #000;
                }

                input {
                    flex: 1 1 100%;
                    border: 2px solid #f2f0eb;
                    height: 39px;
                    padding-left: 10px;
                    background-color: #f2f0eb;
                    border-radius: 5px;
                }

                .label-container {
                    display: flex;
                    flex: 1;

                    label {
                        flex: 1;
                    }
                    .link {
                        flex: 1.5;
                        text-align: right;

                        a {
                            color: #000;
                            font-size: 0.8rem;
                            color: #702716;
                            &:hover {
                                opacity: 0.7;
                            }
                        }
                    }
                }

                .btn-container {
                    flex: 1;
                    text-align: left;

                    button {
                        color: #fff;
                        border: none;
                        background-color: #f74d33;
                        font-weight: 700;
                        line-height: 1;
                        height: 60px;
                        width: 100%;
                        max-width: 112px;
                        border-radius: 5px;
                        border: 1px solid #f74d33;
                        ${TransitionMixin('.25s')}

                        &:hover {
                            color: #f74d33;
                            background-color: #fff;
                        }
                    }
                }
                .link-container {
                    flex: 1.5;
                    text-align: right;
                    p {
                        margin: 0;
                        font-size: 0.8rem;

                        a {
                            color: #000;
                            color: #702716;
                            &:hover {
                                opacity: 0.7;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [customerAccessTokenCreate, { moreData }] = useMutation(
        LOGIN_MUTATION
    );

    // TODO: remove login info
    async function handleFormSubmit(e) {
        e.preventDefault();
        await customerAccessTokenCreate({
            variables: {
                input: {
                    email: 'sam@waveymediagroup.com',
                    password: 'goose123',
                },
            },
        })
            .then((res) => {
                console.log('token created', res);
                console.log('More Data', moreData);

                if (typeof window !== 'undefined') {
                    let cid = {
                        token:
                            res.data.customerAccessTokenCreate
                                .customerAccessToken.accessToken,
                        expiresAt:
                            res.data.customerAccessTokenCreate
                                .customerAccessToken.expiresAt,
                    };
                    localStorage.setItem('cid', JSON.stringify(cid));
                }
            })
            .then(() => {
                navigate('/accounts/dashboard');
            });
        // .error((err) => {});
    }
    return (
        <LoginContainer>
            <SEO title="Login" />
            <Wrapper className="form-container">
                <div className="title-container">
                    <h1>Login.</h1>
                </div>

                <form onSubmit={(e) => handleFormSubmit(e)}>
                    <div className="input-container">
                        <label htmlFor="email">Email</label>
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            type="email"
                            name="email"
                            required
                        />
                    </div>
                    <div className="input-container">
                        <div className="label-container">
                            <label htmlFor="password">Password</label>
                            <div className="link">
                                <a href="#">Forgot your password?</a>
                            </div>
                        </div>
                        <input
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            type="password"
                            name="password"
                            required
                        />
                    </div>
                    <div className="input-container submit">
                        <div className="btn-container">
                            <button type="submit">Login</button>
                        </div>
                        <div className="link-container">
                            <p>
                                New account?{' '}
                                <Link to="/accounts/signup">
                                    Create one here
                                </Link>
                            </p>
                        </div>
                    </div>
                </form>
            </Wrapper>
        </LoginContainer>
    );
};

export default Login;
